import { render, staticRenderFns } from "./BalancePointsCard.vue?vue&type=template&id=fc158c7a&scoped=true"
import script from "./BalancePointsCard.vue?vue&type=script&lang=ts"
export * from "./BalancePointsCard.vue?vue&type=script&lang=ts"
import style0 from "./BalancePointsCard.vue?vue&type=style&index=0&id=fc158c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc158c7a",
  null
  
)

export default component.exports